import React from 'react';
import { debounce, IconButton, InputBase, makeStyles, Paper } from '@material-ui/core';
import { Search } from '@material-ui/icons';

const useStyles = makeStyles({
  searchBox: {
    height: '32px',
    borderRadius: '4px',
    padding: '6px 16px 6px 16px',
  },
  searchText: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '16.8px',
    textAlign: 'left',
    width: '95%',
  },
  searchIcon: {
    padding: '4px',
  },
});
const CustomSearch = ({ placeholder, handleSearch, customStyles, disabled }) => {
  const classes = useStyles(customStyles);
  return (
    <Paper component="form" className={classes.searchBox}>
      <IconButton type="button" className={classes.searchIcon} aria-label="search">
        <Search />
      </IconButton>
      <InputBase
        onChange={debounce(handleSearch, 300)}
        className={classes.searchText}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'search google maps' }}
        fullWidth
        disabled={disabled}
      />
    </Paper>
  );
};

export default React.memo(CustomSearch);
